import React, { useRef, Fragment } from 'react'
import scrollToComponent from 'react-scroll-to-component'
import { isAppWebView } from 'lib/utils/common/commonUtils'
import TTBHBrowserOnlySection from './browser-only-section'
import TTBFaq from './ttb-faq'
import TTBHomeHeader from './ttb-header'
import TTBStep from './ttb-step'

const TTBHome = () => {
  const stepSectionWrapper = useRef(null)

  const toNextSection = (e) => {
    e?.preventDefault()

    scrollToComponent(stepSectionWrapper.current, {
      offset: -52,
      align: 'top',
      duration: 1050,
      ease: 'outExpo',
    })
  }

  return (
    <Fragment>
      <TTBHomeHeader toNextSection={toNextSection} />
      <TTBStep reference={stepSectionWrapper} />
      {isAppWebView() ? <TTBFaq isAppWebView /> : <TTBHBrowserOnlySection />}
    </Fragment>
  )
}

export default TTBHome
